export default "__VITE_ASSET__DWBjbY3e__"